import { ReactNode } from 'react';

import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { Button } from '@vk-hr-tek/ui/Button';

/**
 * Свойства компонента {@link FormButton}
 */
interface FormButtonProps {
  /**
   * Дочерние элементы, отображаемые внутри кнопки.
   */
  children: ReactNode;

  /**
   * Атрибут для тестирования компонента.
   */
  testId?: string;

  /**
   * Флаг, указывающий, отключена ли кнопка.
   *
   * @defaultValue `false`
   */
  disabled?: boolean;

  /**
   * Флаг, указывающий, находится ли кнопка в состоянии загрузки.
   *
   * @defaultValue `false`
   */
  loading?: boolean;
}

/**
 * Компонент кнопки для формы.
 *
 * @public
 * @param children - Дочерние элементы, отображаемые внутри кнопки.
 * @param disabled - Флаг, указывающий, отключена ли кнопка.
 * @param loading - Флаг, указывающий, находится ли кнопка в состоянии загрузки.
 * @param testId - Атрибут для тестирования компонента.
 * @returns Компонент кнопки для формы.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link FormButtonProps}
 */
export const FormButton = ({
  children,
  testId,
  disabled = false,
  loading = false,
}: FormButtonProps) => {
  const isDesktop = useIsDesktop();

  return (
    <Button
      className="qaSubmitButton"
      disabled={disabled}
      fullWidth
      loading={loading}
      size={isDesktop ? 'large' : 'medium'}
      type="submit"
      testId={testId}
    >
      {children}
    </Button>
  );
};
